import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { CheckCircle } from "@material-ui/icons";
import { Grid } from "@material-ui/core";
import { Button } from "react-bootstrap";

const SuccessPage = ({
  projectInfo,
  formState,
  requestCallback,
  projectId
}) => {
  const history = useHistory();
  const [requestId, setRequestId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Execute the request callback when component mounts
  useEffect(() => {
    (async () => {
      // // temp
      // setRequestId(123456789);
      // setError(null);
      // setLoading(false);

      if (requestCallback?.callBack) {
        try {
          setLoading(true);
          const result = await requestCallback.callBack();
          setRequestId(result.requestId);
          setError(null);
        } catch (err) {
          console.error("Error executing request:", err);
          setError("Failed to submit request. Please try again.");
        } finally {
          setLoading(false);
        }
      } else {
        setLoading(false);
      }
    })();
  }, [requestCallback]);

  const handleBackToProject = () => {
    history.push(`/project/${projectId}`);
  };

  const handleViewRequests = () => {
    // Navigate to the requests page for this project
    history.push(`/project/${projectId}/requests`);
  };

  const handleCreateAnother = () => {
    // Reset and start over
    history.push(`/project/${projectId}/status-review/create`);
  };

  if (loading) {
    return (
      <Grid item xs={12} style={{ textAlign: "center", padding: "40px" }}>
        <h1>Submitting your request...</h1>
      </Grid>
    );
  }

  if (error) {
    return (
      <Grid item xs={12} style={{ textAlign: "center", padding: "40px" }}>
        <Grid item xs={12} style={{ color: "#d02f2f", marginBottom: "30px" }}>
          <h1>Submission Failed</h1>
          <p style={{ fontSize: "16px", marginBottom: "30px" }}>{error}</p>
        </Grid>
        <Grid container spacing={2} style={{ justifyContent: "center" }}>
          <Grid item>
            <Button 
              className="back-button"
              style={{width: "150px"}}
              onClick={handleBackToProject}
            >
              Back to Project
            </Button>
          </Grid>
          <Grid item>
            <Button
              className="btn-submit"
              onClick={() => window.location.reload()}
            >
              Try Again
            </Button>
          </Grid>
        </Grid>
      </Grid>
    );
  }

  return (
    <Grid item xs={12} style={{ textAlign: "center", padding: "40px" }}>
      <Grid item xs={12} style={{ marginBottom: "20px" }}>
        <CheckCircle style={{ fontSize: "80px", color: "#28a745", marginBottom: "20px" }} />
        <h1>Request Submitted Successfully!</h1>
      </Grid>
      
      <Grid item xs={12} style={{ marginBottom: "30px" }}>
        <h6>Step 5 of 5 - Completion</h6>
        <p style={{ fontSize: "16px", marginBottom: "30px" }}>
          Your status review request has been submitted and is now pending review by Fannie Mae.
        </p>
      </Grid>

      <Grid item xs={12} style={{ 
        display: "flex",
        justifyContent: "center",
        marginBottom: "30px"
      }}>
        <div style={{ 
          background: "#f8f9fa", 
          padding: "20px", 
          borderRadius: "8px", 
          textAlign: "left",
          maxWidth: "600px",
          width: "100%",
          border: "1px solid #e6e8ed"
        }}>
          <h3 style={{ marginTop: 0, color: "#333", marginBottom: "15px" }}>Request Summary:</h3>
          <div style={{ marginBottom: "8px" }}>
            <strong>Project:</strong> {projectInfo?.projectName}
          </div>
          <div style={{ marginBottom: "8px" }}>
            <strong>Request Type:</strong> {formState?.requestType}
          </div>
          <div style={{ marginBottom: "8px" }}>
            <strong>Current Fannie Mae Review Status:</strong> {projectInfo?.fnmaReviewStatus}
          </div>
          {formState?.selectedReasonCodes?.length > 0 && (
            <div style={{ marginBottom: "8px" }}>
              <strong>Reason Codes:</strong> {formState.selectedReasonCodes.map(rc => rc.label).join(", ")}
            </div>
          )}
          {formState?.comments && (
            <div>
              <strong>Comments:</strong> {formState.comments}
            </div>
          )}
        </div>
      </Grid>

      <Grid item xs={12} style={{ 
        display: "flex",
        justifyContent: "center",
        marginBottom: "30px"
      }}>
        <div style={{ 
          background: "#e7f3ff", 
          padding: "15px", 
          borderRadius: "8px", 
          color: "#1976d2",
          maxWidth: "600px",
          width: "100%",
          border: "1px solid #b3d9ff"
        }}>
          <h3 style={{ marginTop: 0, marginBottom: "15px" }}>What happens next?</h3>
          <ul style={{ margin: 0, paddingLeft: "20px", textAlign: "left" }}>
            <li>Your request has been sent to Fannie Mae for review.</li>
            <li>Processing times vary based on the complexity of the request.</li>
            <li>You can track progress in the project’s Request Feed or the Lender Project Request Queue.</li>
          </ul>
        </div>
      </Grid>

      <Grid container spacing={2} style={{ justifyContent: "center" }}>
        <Grid item>
          <Button 
            className="btn-submit"
            onClick={handleBackToProject}
          >
            Back to Project
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default SuccessPage;